import LineItemTaxInfo from './LineItemTaxInfo';

type Price = {
  taxed: number;
  untaxed: number;
};

type CoreFee = {
  id: string;
  listPriceCents: Price;
  discountedPriceCents: Price;
  feeTaxInfoIncludedInItemTaxInfo: boolean;
  feeTaxInfo: LineItemTaxInfo;
  feeType: string;
  taxCountry: string;
};

enum CoreFeeV2Target {
  Item = 'Item',
  Shipping = 'Shipping',
}

type CoreFeeV2Authority = {
  name: string;
  country: string;
  state: string;
  city: string;
  county: string;
  postalCode: string;
};

type CoreFeeV2 = {
  id: string;
  chargeId: string;
  listPriceCents: Price;
  discountedPriceCents: Price;
  target: CoreFeeV2Target;
  feeTaxInfoIncludedInTargetTaxInfo: boolean;
  feeTaxInfo: LineItemTaxInfo;
  feeType: string;
  taxCountry: string;
  authority: CoreFeeV2Authority;
};

class CorePricedItemAdditionalFees {
  fees: CoreFee[];

  feesV2: CoreFeeV2[];

  constructor() {
    this.fees = [];
    this.feesV2 = [];
  }
}

export default CorePricedItemAdditionalFees;
